import React from 'react';

const CAPABILITIES = [
  { title: "Product & UX", detail: "Product design · User experience · Product led growth" },
  { title: "Build & Systems", detail: "Full-stack development · Software design · Sys admin" },
  { title: "Management Methodologies", detail: "Product management · Program management · Project management · Agile · Scrum" },
  { title: "Visual Arts", detail: "Art · Illustration · Photography · Video" },
  { title: "Content & Growth", detail: "Content creation · Inbound marketing · Business development" },
  { title: "Information Design", detail: "Data visualization · Research · Clear product narratives" },
];

const DISCIPLINES = [
  "Photography", "Video", "Development", "Design", "Project management",
  "System admin", "Illustration", "Software design", "Product design",
  "Platform management", "User experience", "Enterprise systems", "Art",
  "Data visualization", "Web hosting", "Inbound marketing", "Content creator",
];

function Capabilities({ img }) {
  return (
    <section className="pb-capabilities">
      <div className="pb-capabilities-bg" style={{ backgroundImage: `url(${img})` }} />

      <div className="pb-capabilities-heading">
        <div>
          <div className="pb-label">
            <span className="pb-label-num">02</span>
            <span className="pb-label-rule" />
            <span className="pb-label-text">Capabilities</span>
          </div>
          <h2 className="pb-heading">One practice. Many ways to make.</h2>
        </div>
      </div>

      <ol className="pb-capability-grid">
        {CAPABILITIES.map(({ title, detail }, i) => (
          <li className="pb-capability" key={title}>
            <div className="pb-capability-header">
              <span className="pb-capability-num">{String(i + 1).padStart(2, '0')}</span>
            </div>
            <div>
              <h3>{title}</h3>
              <p>{detail}</p>
            </div>
          </li>
        ))}
      </ol>

      <div className="pb-disciplines" aria-label={DISCIPLINES.join(', ')}>
        <div className="pb-disciplines-track" aria-hidden="true">
          {[0, 1].map((copy) => (
            <span className="pb-disciplines-run" key={copy}>
              {DISCIPLINES.map((d) => <span key={d}>{d}</span>)}
            </span>
          ))}
        </div>
      </div>
    </section>
  );
}

export default Capabilities;
